var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    transform: "matrix(1 0 0 -1 0 200)",
    fill: "url(#paint0_linear_2001_131)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 100.5C116.412 100.5 129.714 87.1822 129.714 70.75C129.714 54.3178 116.412 41 100 41C83.5875 41 70.2857 54.3178 70.2857 70.75C70.2857 87.1822 83.5875 100.5 100 100.5ZM120.8 107.938H116.923C111.77 110.308 106.036 111.656 100 111.656C93.9643 111.656 88.2536 110.308 83.0768 107.938H79.2C61.975 107.938 48 121.929 48 139.175V148.844C48 155.003 52.9911 160 59.1429 160H140.857C147.009 160 152 155.003 152 148.844V139.175C152 121.929 138.025 107.938 120.8 107.938Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2001_131",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5956E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E541ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionuser);
export default __webpack_public_path__ + "static/media/questionuser.892c349248470e8ab9519c76dec4e23a.svg";
export { ForwardRef as ReactComponent };